import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import ri from "./trigger-condition.js";
var ui = /*#__PURE__*/function () {
  function ui(t, i) {
    _classCallCheck(this, ui);
    this["if"] = t, this.rf = i, this["if"] = t, this.rf = i;
  }
  _createClass(ui, [{
    key: "xc",
    value: function xc(t) {
      if (null == this["if"]) return !1;
      var i = ri.sf(t[0], this["if"]);
      if (!i) return !1;
      var r = null == this.rf || 0 === this.rf.length;
      if (null != this.rf) for (var _i = 0; _i < this.rf.length; _i++) if (this.rf[_i] === t[1]) {
        r = !0;
        break;
      }
      return i && r;
    }
  }, {
    key: "dt",
    value: function dt() {
      return this["if"];
    }
  }], [{
    key: "fromJson",
    value: function fromJson(t) {
      return new ui(t ? t.id : null, t ? t.buttons : null);
    }
  }]);
  return ui;
}();
export { ui as default };